export const privacyPolicy = {
  effectiveDate: "1st August 2024",
  sections: [
    {
      title: "Introduction",
      body: "Access CV Limited (“we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our platform. Please read this policy carefully to understand our views and practices regarding your personal data.",
    },
    {
      title: "Information We Collect",
      body: "We may collect the following types of information:",
      bodyList: [
        "Personal Information: Name, email address, phone number, and other contact details.",
        "Career Data: CV information, certifications, job history, and availability.",
        "Usage Data: Information about how you use our platform, including access times, browser types, and IP addresses.",
        "Cookies: Data collected via cookies to enhance user experience and track site usage.",
      ],
    },
    {
      title: "How We Use Your Information",
      body: "We use the information we collect to:",
      bodyList: [
        "Provide and maintain our platform.",
        "Improve and personalise your experience.",
        "Communicate with you, including sending notifications and updates.",
        "Facilitate recruitment processes between workers, recruiters, and training providers.",
        "Ensure compliance with legal obligations and resolve any disputes.",
      ],
    },
    {
      title: "Sharing Your Information",
      body: "We may share your information with:",
      bodyList: [
        "Recruiters and Training Providers: As part of the services we offer, we may share relevant career data with recruiters and training providers who use our platform.",
        "Service Providers: Third-party vendors who assist in operating our platform.",
        "Legal Requirements: When necessary to comply with the law, respond to legal requests, or protect our rights.",
      ],
    },
    {
      title: "Data Security",
      body: "We implement appropriate technical and organisational measures to protect your data. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
    },
    {
      title: "Your Rights",
      body: "You have the right to:",
      bodyList: [
        "Access the personal data we hold about you.",
        "Request correction of inaccurate or incomplete information.",
        "Request deletion of your personal data.",
        "Object to the processing of your data in certain circumstances.",
        "Withdraw consent at any time, where consent is the basis of processing.",
      ],
    },
    {
      title: "Cookies",
      body: "We use cookies to enhance your experience. You can control and manage cookies through your browser settings.",
    },
    {
      title: "Data Retention",
      body: "We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, or resolve disputes.",
    },
    {
      title: "Third-Party Links",
      body: "Our platform may contain links to third-party websites. We are not responsible for the privacy practices of these websites and encourage you to review their privacy policies.",
    },
    {
      title: "Changes to This Policy",
      body: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.",
    },
    {
      title: "Contact Us",
      body: "If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at info@accesscv.co.uk.",
    },
  ],
};
